<ng-container *transloco="let t">
  <div class="flex flex-col gap-2">
    <span tuiTitle>{{ t('Ajouter une photo') }}</span>

    @if (rejectedFiles().length) {
      <div class="grid grid-cols-3 gap-2 lg:grid-cols-5">
        @for (file of rejectedFiles(); track file.name) {
          <pxc-image-overlay (delete)="removeRejected(file)">
            <div
              class="flex aspect-square w-full select-none flex-col items-center justify-center gap-2 rounded-xl bg-background-error-primary p-2">
              <tui-icon class="text-foreground-error-primary" icon="@tui.image-off" />
              <p class="line-clamp-2 max-w-full break-all text-center text-sm text-text-tertiary">
                {{ file.name }}
              </p>
              <p class="text-center text-xs text-text-tertiary">
                {{ isTooLarge(file) ? fileTooLargeMessage() : t("Ce fichier n'est pas pris en charge") }}
              </p>
            </div>
          </pxc-image-overlay>
        }
      </div>
    }

    <label class="min-h-40!" tuiInputFiles>
      <input
        data-testid="media-picker-upload"
        tuiInputFiles
        [accept]="accept()"
        [maxFileSize]="effectiveMaxFileSize()"
        [multiple]="maxSelectable() !== 1"
        [ngModel]="undefined"
        (ngModelChange)="onFilesAdded($event)"
        (reject)="onReject($event)" />
      <ng-template #base let-dragged>
        <pxc-dropzone-content
          [draggedLabel]="t('Déposez l\'image ici !')"
          [isDragged]="dragged"
          [label]="isLongVideoEnabled() ? t('Ajoutez vos images ou vos vidéos ici') : t('Ajoutez vos images ici')" />
      </ng-template>
    </label>
  </div>

  <pxc-media-list
    [groups]="groups()"
    [hasMore]="hasMore()"
    [isItemSelectable]="isItemSelectable()"
    [isLoadingMore]="isLoadingMore()"
    [itemTemplate]="itemTemplate()"
    [maxSelectable]="maxSelectable()"
    [selectedKeys]="selectedKeys()"
    [uploadedFiles]="uploadedFiles()"
    (groupToggled)="onGroupToggled($event)"
    (itemToggled)="onItemToggled($event)"
    (loadMoreRequest)="loadMoreRequest.emit()" />

  @if (validationError(); as error) {
    <tui-error [error]="t(error)" />
  }
</ng-container>
